module.exports = __webpack_public_path__ + "static/media/Excavating.a9341aaa.png";